import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_LOCALE } from './router';

menuRegistry.registerMenu([
    {
        parent: 'General',
        key: 'Locale',
        name: 'Locale',
        icon: 'fas fa-globe',
        route: { name: ROUTE_NAME_LOCALE }
    }
]);

export default registerRouteForModule(router);
